import { makeStyles } from '@material-ui/core/styles';
export const useLoadingDotsStyles = makeStyles(theme => ({
	loadingDots: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	dot: {
		width: '0.5rem',
		height: '0.5rem',
		backgroundColor: '#333',
		borderRadius: '50%',
		margin: '0 4px',
		color: '#3f3f3f',
		animation: '$bounce 1s infinite',
		'&:nth-child(2)': {
			animationDelay: '0.2s'
		},
		'&:nth-child(3)': {
			animationDelay: '0.4s'
		}
	},
	'@keyframes bounce': {
		'0%, 100%': {
			transform: 'translateY(0)'
		},
		'50%': {
			transform: 'translateY(-12px)'
		}
	}
}));

export default useLoadingDotsStyles;
